
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/account",
      function () {
        return require("private-next-pages/app/account.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/account"])
      });
    }
  